<template>
  <div
    class="te-fixed-bottom-btn fixed bottom-0 z-[1020] mx-auto w-full px-5 py-2"
    :class="isVisible ? 'fade-in' : 'fade-out'"
  >
    <div class="te-fixed-bottom-animation text-center">
      <a
        class="bot_open te-btn-hover text-center"
        href="/counseling/htmlcss-schedule#schedule"
      >
        <img
          class="te-branded-lp-cta mx-auto"
          src="~/assets/images/Te/TeLp/Sidejob/Aff1/cover-btn.webp"
          alt="無料で相談してみる"
          width="286"
          height="69"
        >
      </a>
    </div>
  </div>
</template>

<script lang="ts">
interface Data {
  isVisible: boolean
  targetSections: string[]
}

const options = {
  data(): Data {
    return {
      isVisible: false,
      targetSections: ['#cover', '#cta-last', '#cover-02', '#cta-02-last'],
    }
  },
  async mounted() {
    if (import.meta.client) {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  beforeDestroy() {
    if (import.meta.client) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleScroll(): void {
      const scrollPosition = window.scrollY + 100
      this.isVisible = scrollPosition > 100 && !this.isSectionVisible()
    },
    isSectionVisible(): boolean {
      return this.targetSections.some((id) => {
        const element = document.querySelector(id)
        if (element) {
          const rect = element.getBoundingClientRect()
          return rect.top <= window.innerHeight && rect.bottom >= 0
        }
        return false
      })
    },
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.fade-out {
  transform: translate(0, 100%);
}

.fade-in {
  transform: translate(0, 0%);
}

.te-fixed-bottom-btn {
  background-color: rgba(255, 255, 255, 0.8);
  transition-duration: 0.5s;
}

.te-fixed-bottom-animation {
  bottom: 0.5rem;
  left: 0;
}

.te-branded-lp-cta {
  width: 16.6875rem;
  height: 4.5rem;
}

.te-branded-lp-cta:hover {
  opacity: 0.6;
  transition: all 0.5s ease;
}
</style>
